// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { Field } from 'redux-form'

import {
  AntennaCompliances,
  InputWithUnitToggle,
  LabeledInput,
  SelectFromState,
} from 'components/Form'

const inputRowClass = `display-flex justify-content-between align-items-start flex-wrap-nowrap`

// also used to fill placeholder space because parent justifies content between
const liw = {
  width: `12%`,
}

const AdvancedSearch = ({ change, idRoot, sourceForm }) => {
  // when the application changes, the options for compliance also change.
  // to keep form state properly in sync, update compliance's value to
  // an empty string and let user select the new value.
  const applicationChange = (e, c) => {
    change('adv-complianceId', '')
    c(e)
  }

  return (
    <div>
      <ul className={inputRowClass}>
        <li style={liw}>
          <Field
            component={SelectFromState}
            emptyOptionLabel={`All`}
            id={`${idRoot}status`}
            name={`adv-statusId`}
            selectLabel={`Status`}
            targetSet={`antennaStatuses`} />
        </li>
        <li style={liw}>
          <Field
            id={`${idRoot}gain`}
            label={`Gain (dBi)`}
            name={`adv-gain`}
            component={LabeledInput}
            placeholder={`Gain`}
            type={`text`} />
        </li>
        <li style={liw}>
          <Field
            component={SelectFromState}
            emptyOptionLabel={`All`}
            id={`${idRoot}antenna-application`}
            name={`adv-antennaApplicationId`}
            onChangeCustom={applicationChange}
            selectLabel={`Application`}
            targetSet={`antennaApplications`} />
        </li>
        <li style={liw}>
          <InputWithUnitToggle
            idRoot={`${idRoot}diameter`}
            label={'Diameter'}
            nameRoot={'adv-diameter'}
            placeholder={'Diameter'}
            sourceForm={sourceForm} />
        </li>
        <li style={liw}>
          <Field
            id={`${idRoot}rpe-number`}
            label={`RPE`}
            name={`adv-rpeNumber`}
            component={LabeledInput}
            placeholder={`Radiation Pattern Envelope`}
            type={`text`} />
        </li>
        <li style={liw} />
      </ul>
      <ul className={inputRowClass}>
        <li style={liw}>
          <Field
            component={SelectFromState}
            emptyOptionLabel={`All`}
            id={`${idRoot}classification`}
            name={`adv-classificationId`}
            selectLabel={`Classification`}
            targetSet={`antennaClassifications`} />
        </li>
        <li style={liw}>
          <Field
            id={`${idRoot}beam-width`}
            label={`3dB BW (°)`}
            name={`adv-beamwidth`}
            component={LabeledInput}
            placeholder={`3dB Beamwidth`}
            type={`text`} />
        </li>
        <li style={liw}>
          <AntennaCompliances
            applicationName={'adv-antennaApplicationId'}
            complianceName={'adv-complianceId'}
            id={idRoot}
            sourceForm={'antenna-db-search'} />
        </li>
        <li style={liw}>
          <Field
            id={`${idRoot}reference-code`}
            label={`Reference Code`}
            name={`adv-modifiedAntennaCode`}
            component={LabeledInput}
            placeholder={`Reference Code`}
            type={`text`} />
        </li>
        <li style={liw} />
        <li style={liw} />
      </ul>
    </div>
  )
}

AdvancedSearch.propTypes = {
  change: func.isRequired,
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default AdvancedSearch
